import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ChangeRequestList = Loadable(lazy(() => import("./ChangeRequestList")));
const CreateRequest = Loadable(lazy(() => import("./CreateRequest")));
const ADMSDashboard = Loadable(lazy(() => import("../dashboard/Dashboard")));

const ADMSRoutes = [
  { path: "/adms/requests", element: <ChangeRequestList /> },
  { path: "/adms/requests/:mode", element: <CreateRequest /> },
  { path: "/adms/requests/:mode/:id", element: <CreateRequest /> },
  { path: "/adms/dashboard", element: <ADMSDashboard /> },
];

export default ADMSRoutes;
